module.exports = __webpack_public_path__ + "fonts/ed4b08d2702fa26acc324ef1e89ae837-Roboto-Light.woff2";